const moduloToColorMap: { [key: number]: string } = {
	0: '#f44336',
	1: '#e91e63',
	2: '#9c27b0',
	3: '#673ab7',
	4: '#3f51b5',
	5: '#2196f3',
	6: '#03a9f4',
	7: '#00bcd4',
	8: '#009688',
	9: '#4caf50',
	10: '#8bc34a',
	11: '#cddc39',
	12: '#ffeb3b',
	13: '#ffc107',
	14: '#ff9800',
	15: '#ff5722',
}

const glossary = [
	{
		word: 'Discreto',
		definition: 'La unidad inmatizable.',
		image: 'discreto.svg',
	},
	{
		word: 'Entidad',
		definition:
			'La tercera capa superior en la jerarquía de entes,  "perteneciente" a un ministerio.',
	},
	{
		word: 'Ministerio',
		definition:
			'La segunda capa superior en la jerarquía de entes, "perteneciente" al gobierno nacional.',
	},
	{
		word: 'Programa',
		definition:
			'La cuarta y última capa en la jerarquía de entes, "perteneciente" a una entidad.',
	},
	{
		word: 'Corriente',
		definition:
			'Es aquel gasto que efectúa un estado con la misión de contratar personal o en su defecto aquel destinado a la compra de insumos, bienes y servicios que son esenciales para llevar a cabo de manera satisfactoria las funciones de administración que le caben desplegar. ',
		image: 'corriente.svg',
	},
	{
		word: 'Capital',
		definition:
			'Es aquel gasto que se efectúa para adquirir o actualizar los activos productivos.',
		image: 'capital.svg',
	},
	{
		word: 'Particular',
		definition: 'Que es propio y singular de una persona.',
	},
	{
		word: 'Privado',
		definition: 'Que no pertenece al estado o a su administración.',
	},
	{
		word: 'Público',
		definition: 'Que pertenece al estado o a su administración.',
	},
	{
		word: 'Colmo',
		definition:
			'El ente central y de mayor importancia, alrededor del cuál se construye el sistema.',
	},
]

const definitions = [
	{
		title: '¿Quiénes Somos?',
		description:
			'Somos un grupo de estudiantes de la UTP indignados por el impune robo de fondos públicos. Somos tres personas que entienden que los gobiernos son meros entes administrativos y no tienen colmo propio, e indulgir a funcionarios públicos (sea consejero municipal, presidente de la nación o cualquier puesto de por medio) que actuen como si sí tuvieran colmo propio degrada y frusta el prosperar de un país. Ganadores de la hackathon 2.0 de la UTP bajo la categoría "Transparencia Gubernamental."',
		images: [
			{
				url: process.env.PUBLIC_URL + '/the-bois.jpeg',
				photoTitle: '1er lugar en la Hackathon de Datos Abiertos UTP',
				alt: 'The Bois',
			},
		],
	},

	{
		title: 'Trust For The Americas',
		description:
			'El Trust for the Americas es un afiliado sin fines de lucro 501 de la Organización de Estados Americanos que trabaja para promover el desarrollo económico, social y político en América Latina y el Caribe. Establecido en 1997, funciona a través de asociaciones públicas y privadas.',
		image: {
			url: process.env.PUBLIC_URL + '/trust-logo.png',
			alt: 'Trust for the Americas Logo',
		},
	},
]

export default {
	moduloToColorMap,
	glossary,
	definitions,
}
